import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import Plx from 'react-plx';
import { DragSource, DropTarget } from 'react-dnd';

import { elementSource, elementTarget } from './elementDragUtils';

import LoginForm from 'components/forms/auth/LoginForm';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElement';
import RichEditorContent from 'components/RichEditorContent';

import * as constants from 'js/constants';

@DropTarget('element', elementTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('element', elementSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class CmsElementLoginForm extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      pending: false,
      shown: true,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  showSettings = e => {
    this.props.showElementSettings(e, this.props.index);
  };

  doNothing = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  getSocialMediaButtons = () => {
    const { intl, appIntl } = this.props;
    const messages = intl.messages;

    let res = [];

    res.push(
      <a className="btn btn-social btn-facebook m-l-10 m-t-10" href="#facebook" onClick={this.doNothing} key="f">
        <i className="fab fa-facebook-f m-r-5" /> Facebook
      </a>
    );

    res.push(
      <a className="btn btn-social btn-google m-l-10 m-t-10" href="#google" onClick={this.doNothing} key="g">
        <i className="fab fa-google m-r-5" /> Google
      </a>
    );

    res.push(
      <a className="btn btn-social btn-microsoft m-l-10 m-t-10" href="#microsoft" onClick={this.doNothing} key="m">
        <i className="fab fa-microsoft m-r-5" /> Microsoft
      </a>
    );

    return res;
  };

  onClick = () => {
    clearTimeout(this.timeout);
    this.setState({ pending: !this.state.pending }, () => {
      if (this.state.pending) {
        this.timeout = setTimeout(() => this.setState({ pending: false }), 1000);
      }
    });
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
    this.__componentWillUnmount();
  };

  render() {
    const { intl, appIntl, connectDropTarget, connectDragSource, connectDragPreview } = this.props;
    const { pending, shown } = this.state;
    const messages = intl.messages;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const textClass = 'text-' + this.getParamValue('mainColor', 'master');

    const showSocialMediaLogin = true;

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-login-form-content ' + shownClass + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle() }}
        onClick={this.showSettings}
      >
        {this.getElementStyle()}

        <div className="ms-login-form-container">
          <h4 className={'no-margin p-b-5 ' + textClass}>
            <i className="fa fa-lock m-r-5" />
            {this.getParamValue('title', '')}
          </h4>

          <RichEditorContent content={'<p className="' + textClass + '">' + this.getParamValue('content', '') + '</p>'} />

          <LoginForm onSubmit={() => {}} buttonTitle={this.getParamValue('buttonTitle', messages.button_signin)} />

          {showSocialMediaLogin ? (
            <div className={'m-t-30 ' + textClass}>
              <h4 className={textClass}>
                <center>{messages.alternative_login_long}</center>
              </h4>

              <center>{this.getSocialMediaButtons()}</center>
            </div>
          ) : null}
        </div>

        {this.getAppendHtml()}
      </div>
    );

    return connectDropTarget(
      connectDragSource(
        connectDragPreview(
          <div>
            <ScrollTrigger onEnter={this.shown} {...this.getCustomId()}>
              {parallaxData ? <Plx parallaxData={parallaxData}>{innerContent}</Plx> : innerContent}
            </ScrollTrigger>
          </div>
        )
      )
    );
  }
}
